import {AmazonAddressType} from 'types/amazonType';
import {StatesItemType, StatesType} from 'types/locationType';

type ReturnType = {
    billingRegion: StatesItemType | string;
    shippingRegion: StatesItemType | string;
};

/**
 * Find current region in state regions and return information (id, label)
 * @param {StatesType} regions - regions
 * @param {AmazonAddressType} shippingAddress - Received shipping address
 * @param {AmazonAddressType} billingAddress - Received billing address
 * @return {ReturnType} - Resulted FormData
 */
export const getCurrentRegions = (
    regions: StatesType,
    shippingAddress: AmazonAddressType,
    billingAddress: AmazonAddressType,
): ReturnType => {
    let billingRegion;
    let shippingRegion;

    if (regions[billingAddress.country]) {
        billingRegion = regions[billingAddress.country].find(
            (item: {label: string; value: string}) => item.value === billingAddress.region,
        );
    }

    if (regions[shippingAddress.country]) {
        shippingRegion = regions[shippingAddress.country].find(
            (item: {label: string; value: string}) => item.value === shippingAddress.region,
        );
    }

    return {
        billingRegion: billingRegion ?? billingAddress.region,
        shippingRegion: shippingRegion ?? shippingAddress.region,
    };
};
